/**
 * @generated SignedSource<<b02c8f71717d2c613241a2fc14846f74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateClientAssetModalDefaultApproverQuery$variables = {
  projectId: string;
  taskId?: string | null;
};
export type CreateClientAssetModalDefaultApproverQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly clientAssetDefaultApprover: string | null;
    } | null;
  } | null;
};
export type CreateClientAssetModalDefaultApproverQuery = {
  variables: CreateClientAssetModalDefaultApproverQuery$variables;
  response: CreateClientAssetModalDefaultApproverQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "kind": "ScalarField",
  "name": "clientAssetDefaultApprover",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateClientAssetModalDefaultApproverQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateClientAssetModalDefaultApproverQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae0521f7a796af6944509ac9bd3d45f6",
    "id": null,
    "metadata": {},
    "name": "CreateClientAssetModalDefaultApproverQuery",
    "operationKind": "query",
    "text": "query CreateClientAssetModalDefaultApproverQuery(\n  $projectId: ID!\n  $taskId: ID\n) {\n  viewer {\n    project(internalId: $projectId) {\n      clientAssetDefaultApprover(taskId: $taskId)\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d6895da33794790bf3b613f5d5744bf";

export default node;
